(() => {
  if (document.body.classList.contains('bf-original-home')) {
    const walker = document.createTreeWalker(document.getElementById('MainContent'), NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!node.parentElement.closest('script,style,svg,.bf-home-number,.gps-514258230772237467') && /\d/.test(node.textContent)) nodes.push(node);
    }
    nodes.forEach(node => {
      const parts = node.textContent.split(/((?:[-−]\s*)?\d[\d.,]*(?:\s*[%€])?)/g);
      if (parts.length < 2) return;
      const fragment = document.createDocumentFragment();
      parts.forEach((part, i) => {
        if (i % 2) { const span = document.createElement('span'); span.className = 'bf-home-number'; span.textContent = part; fragment.append(span); }
        else fragment.append(document.createTextNode(part));
      });
      node.replaceWith(fragment);
    });
  }
  document.querySelectorAll('.bf-full-description p').forEach(p => {
    const walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      node.textContent = node.textContent.replace(/^[\s\u00a0\u200b]+/, '');
      if (node.textContent.length) break;
    }
  });
  const sync = () => document.querySelectorAll('.bf-submit-price').forEach(el => { el.hidden = !!el.closest('button')?.disabled; });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, () => queueMicrotask(sync));
})();